/**
 * Accordions
 * Add .is-visible class to Bootstrap collapse elements when they are shown.
 */

export function bootstrapCollapseToggle() {
  const collapseElements = document.querySelectorAll(
    ".accordion-item .collapse",
  );

  if (!collapseElements.length) {
    return;
  }

  collapseElements.forEach((el) => {
    const accordionItem = el.closest(".accordion-item");
    if (!accordionItem) {
      return;
    }

    // On page load, if element is already shown (has .show class), add .is-visible to the parent.
    if (el.classList.contains("show")) {
      accordionItem.classList.add("is-visible");
    }

    // When a collapse element begins to show, add .is-visible to the parent.
    el.addEventListener("show.bs.collapse", () => {
      accordionItem.classList.add("is-visible");
    });

    // When a collapse element begins to hide, remove .is-visible from the parent.
    el.addEventListener("hide.bs.collapse", () => {
      accordionItem.classList.remove("is-visible");
    });
  });
}
